import { useIsAvaBasePath } from '@/app/hooks/ava/useAvaVerification'
import useMultiProgramFlowControl from '@/hooks/useMultiProgramFlowControl'

export default function useSkipTeslaVirtualKeyUrl() {
  const isAva = useIsAvaBasePath()
  const { inFlow, popFlowUri } = useMultiProgramFlowControl()

  if (isAva) {
    return `/ava/onboarding/add-another`
  }

  if (inFlow) {
    const multiProgramUri = popFlowUri()
    if (multiProgramUri) {
      return multiProgramUri
    }
  }

  return `/connect-vehicle/configure`
}
